<style scoped>
.v-application .subtitle-1 {
  font-size: 14px !important;
  font-weight: normal;
  letter-spacing: 0.009375em !important;
  line-height: 1.75rem;
  font-family: "Prompt", sans-serif !important;
}
.checked-done:after {
  content: "\2713";
  font-weight: bolder;
  font-size: 22px;
  color: #008033;
  opacity: 1;
  left: -4px;
  top: 20px;
  background-color: #ffffff00;
}
.color-done {
  color: #008033;
}
</style>

<template>
  <v-menu offset-y absolute v-model="isOpened">
    <template v-slot:activator="{ on }">
      <v-btn
        outlined
        color="black"
        elevation="0"
        small
        class="mb-0"
        style="width: 30px; min-width: 35px"
        v-on="on"
      >
        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, i) in subMenu"
        :key="i"
        @click="menu_list(item)"
        class="mb-n3 mt-n1 mx-n1"
      >
        <v-list-item-avatar style="width: 20px; min-width: 20px">
          <v-icon :class="item.isChecked" v-text="item.icon"></v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title :class="item.fcolor">{{
            item.title
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import moment from "moment";
export default {
  name: "TableMenuCustomer",
  props: {
    TableData: Object,
    whichPage: String,
  },
  data: () => ({
    subMenu: [],
    isOpened: null, 
  }),
  created() {
    this.menuDetail();
  },
  watch: {
    isOpened(event) {
      if (event) {
        this.menuDetail();
        this.menuColor();
      }
    },
  },
  computed: {},
  methods: {
    ...mapMutations({
      SET_ALL_ELEMENT: "CustomerDetail/SET_ALL_ELEMENT",
      CU_SET: "CustomerDetail/SET_ELEMENT",
      CU_EDIT: "CustomerDetail/SET_IS_EDIT",
      CU_MERGE: "CustomerDetail/MERGE_ALL_ELEMENT",
      SET_PRODUCT: "CustomerDetail/SET_PRODUCT_LIST",
      Q_SET_PRODUCT: "Quotation/SET_PRODUCT_LIST",
      Q_SET_ALL: "Quotation/SET_ALL_ELEMENT",
      Q_MERGE: "Quotation/MERGE_ALL_ELEMENT",
      Q_SET: "Quotation/SET_ELEMENT",
      Q_EDIT: "Quotation/SET_IS_EDIT",
      B_SET_PRODUCT: "Bill/SET_PRODUCT_LIST",
      B_SET_ALL: "Bill/SET_ALL_ELEMENT",
      B_MERGE: "Bill/MERGE_ALL_ELEMENT",
      B_SET: "Bill/SET_ELEMENT",
      B_EDIT: "Bill/SET_IS_EDIT",
      B_SPLITING: "Bill/SET_SPLITING",
      C_EDIT: "Contract/SET_IS_EDIT",
      C_SET_PRODUCT: "Contract/SET_PRODUCT_LIST",
      C_SET_ALL: "Contract/SET_ALL_ELEMENT",
      C_MERGE: "Contract/MERGE_ALL_ELEMENT",
      I_SET: "Invoice/SET_ELEMENT",
      I_EDIT: "Invoice/SET_IS_EDIT",
      I_SET_PRODUCT: "Invoice/SET_PRODUCT_LIST",
      I_SET_ALL: "Invoice/SET_ALL_ELEMENT",
      I_MERGE: "Invoice/MERGE_ALL_ELEMENT",
      I_SET: "Invoice/SET_ELEMENT",
      I_SPLITING: "Invoice/SET_SPLITING",
      I_ISMENU: "Invoice/SET_IS_MENU",
      LOADER: "Drawer/SET_LOADER",
      SET_STEP: "Drawer/SET_STEP",
      STEP1_COMPLETE: "Drawer/SET_STEP1_COMPLETE",
      STEP2_COMPLETE: "Drawer/SET_STEP2_COMPLETE",
      W_SET_ELEMENT: "Waste/SET_ELEMENT",
    }),
    ...mapActions({
      SET_DAYS: "CustomerDetail/addTran",
      INIT_DAYS: "CustomerDetail/initDays",
    }),
    menuDetail() {
      if (this.whichPage == "new_cus") {
        this.subMenu = [
          {
            icon: "mdi-file-check-outline",
            title: "กรอกข้อมูลเพิ่มเติม",
            isChecked: "",
            fcolor: "my-n5 subtitle-1",
          },
          {
            icon: "mdi-trash-can-outline",
            title: "ลบผู้ติดต่อ",
            isChecked: "",
            fcolor: "my-n5 subtitle-1",
          },
        ];
      } else if (this.whichPage == "regis_cus") {
        this.subMenu = [
          {
            icon: "mdi-chart-timeline-variant",
            title: "รายงานเก็บขน",
            isChecked: "",
            fcolor: "my-n5 subtitle-1",
          },
          {
            icon: "mdi-file-document-edit-outline",
            title: "แก้ไขผู้ติดต่อ",
            isChecked: "",
            fcolor: "my-n5 subtitle-1",
          },
          // { icon: "mdi-content-copy", title: "สร้างซ้ำ", isChecked: "", fcolor: "my-n5 subtitle-1" },
          {
            icon: "mdi-file-document-outline",
            title: "สร้างใบเสนอราคา",
            isChecked: "",
            fcolor: "my-n5 subtitle-1",
          },
          {
            icon: "mdi-file-document-outline",
            title: "สร้างใบวางบิล / แจ้งหนี้",
            isChecked: "",
            fcolor: "my-n5 subtitle-1",
          },
          {
            icon: "mdi-file-document-outline",
            title: "สร้างใบกำกับภาษี",
            isChecked: "",
            fcolor: "my-n5 subtitle-1",
          },
          {
            icon: "mdi-file-clock-outline",
            title: "สร้างสัญญา",
            isChecked: "",
            fcolor: "my-n5 subtitle-1",
          },
          {
            icon: "mdi-share",
            title: "ลิงค์ลูกค้า",
            isChecked: "",
            fcolor: "my-n5 subtitle-1",
          },
          {
            icon: "mdi-close",
            title: "ยกเลิกลูกค้า",
            isChecked: "",
            fcolor: "my-n5 subtitle-1",
          },

          {
            icon: "mdi-redo-variant",
            title: "รีเซ็ต",
            isChecked: "",
            fcolor: "my-n5 subtitle-1",
          },
        ];
      } else if (this.whichPage == "waste_Doc") {
        this.subMenu = [
          { icon: "mdi-printer", title: "พิมพ์ใบ ตช." },
          { icon: "mdi-file-document-edit-outline", title: "แก้ไข ตช." },
          // { icon: "mdi-file-clock-outline", title: "ดูใบ ตช." },
        ];
      } else if (this.whichPage == "person_Edit") {
        this.subMenu = [
          { icon: "mdi-file-document-edit-outline", title: "แก้ไข" },
          { icon: "mdi-trash-can-outline", title: "ลบ" },
          // { icon: "mdi-file-clock-outline", title: "ดูใบ ตช." },
        ];
      } else if (this.whichPage == "car_Edit") {
        this.subMenu = [
          { icon: "mdi-file-document-edit-outline", title: "แก้ไข" },
          { icon: "mdi-trash-can-outline", title: "ลบ" },
        ];
      } else {
        this.subMenu = [
          {
            icon: "mdi-file-document-edit-outline",
            title: "แก้ไขผู้ติดต่อ",
            isChecked: "",
            fcolor: "my-n5 subtitle-1",
          },
          {
            icon: "mdi-trash-can-outline",
            title: "ลบผู้ติดต่อ",
            isChecked: "",
            fcolor: "my-n5 subtitle-1",
          },
        ];
      }
    },
    async menu_list(item) {
      if (this.whichPage == "new_cus") {
        if (item.title == "กรอกข้อมูลเพิ่มเติม") {
          this.LOADER(true);

          let response = await this.$token_api
            .post("/get-customer-days", {
              CUSTOMER_ID: this.TableData.NEWCUSTOMER_ID,
            })
            .catch((err) => {
              this.LOADER(false);
            });
          let day_data = response.data.data;
          console.log(day_data.length);
          if (day_data.length > 0) {
            this.SET_DAYS(day_data);
            this.CU_MERGE(this.TableData);
            this.$router.push({ path: "/newCustomer/add-newCustomer" });
            this.LOADER(false);
          } else {
            this.INIT_DAYS();
            this.CU_MERGE(this.TableData);
            this.$router.push({ path: "/newCustomer/add-newCustomer" });
            this.LOADER(false);
          }
        } else if (item.title == "ลบผู้ติดต่อ") {
          //console.log(this.TableData);
          this.$swal({
            title: "ต้องการลบข้อมูลหรือไม่",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
          }).then((result) => {
            if (result.value) {
              console.log(this.TableData);
              this.$token_api
                .post("/delete-Customer", {
                  n_cusid: this.TableData.NEWCUSTOMER_ID,
                })
                .then((res) => {
                  this.$emit("reData");
                })
                .catch((e) => {
                  console.log(err);
                });
            }
          });
        }
      } else if (this.whichPage == "regis_cus") {
        if (item.title == "แก้ไขผู้ติดต่อ") {
          await this.goToEditCus();
        } else if (item.title == "รายงานเก็บขน") {
          window.open(
            `${this.$global_link}/Customer/${this.TableData.NEWCUSTOMER_ID}`,
            "_blank"
          );
        } else if (item.title == "สร้างใบเสนอราคา") {
          await this.goToQuotation();
        } else if (item.title == "สร้างใบวางบิล / แจ้งหนี้") {
          if (this.TableData.QUOTATION_ID) {
            await this.goToBill();
          } else {
            this.$swal({
              title: "ไม่พบเอกสาร",
              text: "ไม่พบเอกสารเสนอราคา หรือ เอกสารถูกยกเลิก",
              timer: 3000,
              icon: "warning",
            });
          }
        } else if (item.title == "สร้างสัญญา") {
          await this.goToContract();
        } else if (item.title == "สร้างใบกำกับภาษี") {
          await this.goToInvoice();
        } else if (item.title == "รีเซ็ต") {
          this.reset_customer();
        } else if (item.title == "ลิงค์ลูกค้า") {
          this.$parent.$parent.$parent.$parent.showDialog(
            this.TableData.NEWCUSTOMER_ID
          );
        } else {
          this.abort_customer();
        }
      } else if (this.whichPage == "waste_Doc") {
        if (item.title == "พิมพ์ใบ ตช.") {
          // this.TableData.urlO =
          //   this.$img_url_O + "/" + this.TableData.T_ID + ".jpg";

          // this.TableData.urlR =
          //   this.$img_url_R + "/" + this.TableData.T_ID + ".jpg";
          // console.log(this.TableData);
          let desSigPic;
          await this.$guest_api
            .get(`/get-des-des_sig_pic/${this.TableData.T_ID}`)
            .then((res) => {
              desSigPic = res.data.data[0].TR_DESTROY_ID;
              console.log(desSigPic);
            })
            .catch((err) => {
              console.log(err);
            });
          if (desSigPic) {
            this.TableData.urlO =
              this.$img_url_O + `/${this.TableData.T_ID}.jpg`;
            this.TableData.urlR = this.$img_url_R + "/" + desSigPic + ".jpg";
          } else {
            this.TableData.urlO =
              this.$img_url_O + `/${this.TableData.T_ID}.jpg`;
            this.TableData.urlR = this.$img_url_R + "/" + "0" + ".jpg";
          }
          console.log("set global_link " + this.TableData.T_ID);
          this.TableData.rootURL =
            this.$global_link + `/l-Doc/${this.TableData.T_ID}`;
          this.$emit("myEvent", this.TableData);
        } else if (item.title == "แก้ไข ตช.") {
          await this.editWaste_Doc();
        }
      } else if (this.whichPage == "person_Edit") {
        if (item.title == "แก้ไข") {
          //console.log(this.TableData);

          this.$store.commit("Personnel/SET_getEdit", true);
          this.$store.commit(
            "Personnel/SET_PERSONNEL_CID",
            this.TableData.PERSONNEL_CID
          );
          this.$store.commit(
            "Personnel/SET_PERSONNEL_NAMETYPE",
            this.TableData.PERSONNEL_NAMETYPE
          );
          this.$store.commit(
            "Personnel/SET_PERSONNEL_NAME",
            this.TableData.PERSONNEL_NAME
          );
          this.$store.commit(
            "Personnel/SET_PERSONNEL_LASTNAME",
            this.TableData.PERSONNEL_LASTNAME
          );
          this.$store.commit(
            "Personnel/SET_PERSONNEL_ADDRESS",
            this.TableData.PERSONNEL_ADDRESS
          );
          this.$store.commit(
            "Personnel/SET_PERSONNEL_PHONE",
            this.TableData.PERSONNEL_PHONE
          );
          this.$store.commit(
            "Personnel/SET_PERSONNEL_POSITION",
            this.TableData.PERSONNEL_POSITION
          );
          this.$store.commit(
            "Personnel/SET_PERSONNEL_SUBDISTRICT",
            this.TableData.PERSONNEL_SUBDISTRICT
          );
          this.$store.commit(
            "Personnel/SET_PERSONNEL_DISTRICT",
            this.TableData.PERSONNEL_DISTRICT
          );
          this.$store.commit(
            "Personnel/SET_PERSONNEL_PROVINCE",
            this.TableData.PERSONNEL_PROVINCE
          );
          this.$store.commit(
            "Personnel/SET_PERSONNEL_ZIPCODE",
            this.TableData.PERSONNEL_ZIPCODE
          );
          this.$router.push({ path: "/manage/add-personnel" });
        } else if (item.title == "ลบ") {
          this.$swal({
            title: "ลบข้อมูล",
            text: `กรุณากดปุ่ม "ยีนยัน" เพื่อลบข้อมูล`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
          }).then((result) => {
            if (result.value) {
              //console.log(item.CAR_ID)
              //ยังลบไม่ได้ ติด FOREIGN KEY
              this.$token_api
                .post("/delete-Personnel", {
                  PERSONNEL_CID: this.TableData.PERSONNEL_CID,
                })
                .then((response) => {
                  // console.log(response.data);
                  this.$swal("ลบเรียบร้อย", "สำเร็จ", "success");
                  this.$store.dispatch("Personnel/preson_reset");
                  this.$emit("myEvent");
                })
                .catch((err) => {
                  this.$swal("เกิดข้ผิดพลาด", "ลองใหม่อีกครั้ง", "error");
                });
            }
          });
          //console.log(this.TableData);
        }
      } else if (this.whichPage == "car_Edit") {
        if (item.title == "แก้ไข") {
          //console.log(this.TableData);
          this.$store.commit("Carrier/SET_CAR_AUTO_ID", this.TableData.CAR_ID);
          this.$store.commit(
            "Carrier/SET_CAR_NUMBER",
            this.TableData.CAR_NUMBER
          );
          this.$store.commit("Carrier/SET_CAR_TYPE", this.TableData.CAR_TYPE);
          this.$store.commit("Carrier/SET_CAR_BRAND", this.TableData.CAR_BRAND);
          this.$store.commit(
            "Carrier/SET_CAR_GENERATION",
            this.TableData.CAR_GENERATION
          ); 
           this.$store.commit(
            "Carrier/SET_CAR_CODE",
            this.TableData.CAR_CODE
          );
          this.$store.commit("Carrier/SET_isEdit", true);
          this.$router.push({ path: "/manage/add-Car" });
        } else if (item.title == "ลบ") {
          this.$swal({
            title: "ลบข้อมูลรถ",
            text: `กรุณากดปุ่ม "ยีนยัน" เพื่อลบข้อมูล`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
          }).then((result) => {
            if (result.value) {
              //console.log(item.CAR_ID)
              //ยังลบไม่ได้ ติด FOREIGN KEY
              console.log(this.TableData.CAR_ID);
              this.$token_api
                .post("/delete-car", { CAR_ID: this.TableData.CAR_ID })
                .then((response) => {
                  console.log(response.data);
                  this.$swal("ลบเรียบร้อย", "สำเร็จ", "success");
                  this.$store.dispatch("Carrier/car_reset");
                  this.$emit("myCarEvent");
                })
                .catch((err) => {
                  console.log(err);
                  this.$swal("เกิดข้ผิดพลาด", "ลองใหม่อีกครั้ง", "error");
                });
            }
          });
        }
      }
    },
    checkDone() {},
    menuColor() {
      let arr_sub = this.subMenu;
      if (this.TableData.STATUS == "รอเสนอราคา") {
        let filter = arr_sub.filter((x) => {
          return (
            x.title != "สร้างสัญญา" &&
            x.title != "สร้างใบวางบิล / แจ้งหนี้" &&
            x.title != "ลิงค์ลูกค้า" &&
            x.title != "สร้างใบกำกับภาษี" &&
            x.title != "รายงานเก็บขน"
          );
        });
        this.subMenu = filter;
      } else if (this.TableData.STATUS == "หมดสัญญา") {
        let filter = arr_sub.filter((x) => {
          return (
            x.title != "สร้างสัญญา" &&
            x.title != "สร้างใบวางบิล / แจ้งหนี้" &&
            x.title != "ลิงค์ลูกค้า" &&
            x.title != "สร้างใบกำกับภาษี"
          );
        });
        this.subMenu = filter;
      } else if (this.TableData.STATUS == "รอวางบิล") {
        let filter = arr_sub.filter((x) => {
          return (
            x.title != "สร้างใบเสนอราคา" &&
            x.title != "สร้างสัญญา" &&
            x.title != "สร้างใบกำกับภาษี" &&
            x.title != "รายงานเก็บขน"
          );
        });
        this.subMenu = filter;
      } else if (this.TableData.STATUS == "รอการชำระเงิน") {
        let filter = arr_sub.filter((x) => {
          return (
            x.title != "สร้างใบเสนอราคา" &&
            x.title != "สร้างสัญญา" &&
            x.title != "สร้างใบวางบิล / แจ้งหนี้" &&
            x.title != "รายงานเก็บขน"
          );
        });
        this.subMenu = filter;
      } else if (this.TableData.STATUS == "รอทำสัญญา") {
        let filter = [];
        if (this.TableData.SPLIT_PAY == 1) {
          filter = arr_sub.filter((x) => {
            return x.title != "สร้างใบเสนอราคา";
          });
        } else {
          filter = arr_sub.filter((x) => {
            return (
              x.title != "สร้างใบเสนอราคา" &&
              x.title != "สร้างใบวางบิล / แจ้งหนี้" &&
              x.title != "สร้างใบกำกับภาษี" &&
              x.title != "รายงานเก็บขน"
            );
          });
        }
        this.subMenu = filter;
      } else if (this.TableData.STATUS == "ดำเนินการ") {
        let filter = [];
        let p_val = parseFloat(this.TableData.PREVIOUS_VALUE);
        let split_val = parseFloat(this.TableData.SPLIT_VALUE);
        let all_pay = p_val - split_val;
        if (this.TableData.SPLIT_PAY == 1) {
          if (all_pay == 0) {
            filter = arr_sub.filter((x) => {
              return (
                x.title != "สร้างใบเสนอราคา" &&
                x.title != "สร้างสัญญา" &&
                x.title != "สร้างใบวางบิล / แจ้งหนี้" &&
                x.title != "สร้างใบกำกับภาษี"
              );
            });
          } else {
            filter = arr_sub.filter((x) => {
              return x.title != "สร้างใบเสนอราคา" && x.title != "สร้างสัญญา";
            });
          }
        } else {
          filter = arr_sub.filter((x) => {
            return (
              x.title != "สร้างใบเสนอราคา" &&
              x.title != "สร้างสัญญา" &&
              x.title != "สร้างใบวางบิล / แจ้งหนี้" &&
              x.title != "สร้างใบกำกับภาษี"
            );
          });
        }
        this.subMenu = filter;
      } else if (this.TableData.STATUS == "ยกเลิก") {
        let filter = arr_sub.filter((x) => {
          return (
            x.title != "สร้างใบเสนอราคา" &&
            x.title != "สร้างสัญญา" &&
            x.title != "สร้างใบกำกับภาษี" &&
            x.title != "สร้างใบวางบิล / แจ้งหนี้" &&
            x.title != "ลิงค์ลูกค้า" &&
            x.title != "ยกเลิกลูกค้า"
          );
        });
        this.subMenu = filter;
      }
    },
    async goToQuotation() {
      this.LOADER(true);
      let response = await this.$token_api
        .post("/get-customer-edit-detail", {
          NEWCUSTOMER_ID: this.TableData.NEWCUSTOMER_ID,
          STATUS: this.TableData.STATUS,
        })
        .catch((err) => {
          this.LOADER(false);
        });
      let data = response.data;
      if (data.length > 0) {
        this.SET_STEP(1);
        this.CU_SET({ key: "NEWCUSTOMER_ID", value: data[0].NEWCUSTOMER_ID });
        this.Q_MERGE(data[0]);
        this.Q_SET_PRODUCT(data[0].LIST_PRODUCT);
        this.$router.push({ path: "/form" });
        this.LOADER(false);
      } else {
        this.LOADER(false);
      }
    },
    async goToBill() {
      this.LOADER(true);
      let response = await this.$token_api
        .post("/step-customer-data", {
          NEWCUSTOMER_ID: this.TableData.NEWCUSTOMER_ID,
        })
        .catch((err) => {
          this.LOADER(false);
        });
      let data = response.data.data;
      if (data.length > 0) {
        const prod_detail = await new Response(data[0].PRODUCT_LIST).json();
        let response1 = await this.$token_api
          .post("/find-contract-bill", {
            QUOTATION_ID: this.TableData.QUOTATION_ID,
            CUSTOMER_ID: this.TableData.NEWCUSTOMER_ID,
          })
          .catch((err) => {
            this.LOADER(false);
          });
        let bdata =
          response1.data.data.length > 0 ? response1.data.data[0] : null;
        if (this.TableData.SPLIT_PAY == 1) {
          this.SET_STEP(2);
          this.B_SET({ key: "SPLIT_PAY", value: this.TableData.SPLIT_PAY });
          this.CU_SET({ key: "NEWCUSTOMER_ID", value: data[0].NEWCUSTOMER_ID });
          this.B_SET({
            key: "QUOTATION_ID",
            value: this.TableData.QUOTATION_ID,
          });
          this.B_MERGE(data[0]);
          this.B_SET_PRODUCT(prod_detail);
          this.$router.push({ path: "/form" });
          this.LOADER(false);
          if (this.TableData.SPLIT_OPTION) {
            if (bdata) {
              let not_zero =
                parseInt(bdata.PREVIOUS_VALUE) - parseInt(bdata.SPLIT_VALUE);
              if (not_zero != 0) {
                this.B_SPLITING(true);
                this.B_SET({
                  key: "TEMP_PREVIOUS_VALUE",
                  value: bdata.SPLIT_VALUE,
                });
                this.B_SET({
                  key: "PREVIOUS_VALUE",
                  value: bdata.PREVIOUS_VALUE,
                });
                this.B_SET({ key: "SPLIT_OPTION", value: bdata.SPLIT_OPTION });
                this.B_SET({ key: "SPLIT_VALUE", value: bdata.SPLIT_VALUE });
                this.B_SET({
                  key: "SPLIT_PAY",
                  value: this.TableData.SPLIT_PAY,
                });
              } else {
                this.B_SET({ key: "SPLIT_PAY", value: 0 });
                this.LOADER(false);
              }
            } else {
              this.LOADER(false);
            }
          } else {
            this.B_SPLITING(false);
          }
        } else {
          this.SET_STEP(2);
          this.CU_SET({ key: "NEWCUSTOMER_ID", value: data[0].NEWCUSTOMER_ID });
          this.B_SET({
            key: "QUOTATION_ID",
            value: this.TableData.QUOTATION_ID,
          });
          this.B_MERGE(data[0]);
          this.B_SET_PRODUCT(prod_detail);
          this.$router.push({ path: "/form" });
          this.LOADER(false);
        }
      } else {
        this.LOADER(false);
      }
    },
    async goToContract() {
      //
      this.LOADER(true);

      let response = await this.$token_api
        .post("/step-customer-data", {
          NEWCUSTOMER_ID: this.TableData.NEWCUSTOMER_ID,
        })
        .catch((err) => {
          this.LOADER(false);
        });
      let data = response.data.data;
      console.log(data);
      if (data.length > 0) {
        const prod_detail = await new Response(data[0].PRODUCT_LIST).json();
        this.SET_STEP(3);
        this.C_MERGE(data[0]);
        this.C_SET_PRODUCT(prod_detail);
        // this.C_EDIT(true);
        this.$router.push({ path: "/form" });
        this.LOADER(false);
      } else {
        this.LOADER(false);
      }
    },
    async goToInvoice() {
      //
      this.LOADER(true);
      if (this.TableData.BILL_ID) {
        let response = await this.$token_api
          .post("/find-contract-bill", {
            QUOTATION_ID: this.TableData.QUOTATION_ID,
            CUSTOMER_ID: this.TableData.NEWCUSTOMER_ID,
          })
          .catch((err) => {
            this.LOADER(false);
          });
        let data = response.data.data;
        this.I_SPLITING(false);
        this.I_ISMENU(true);
        if (data.length > 0) {
          const prod_detail = await new Response(data[0].PRODUCT_LIST).json();
          console.log(data);
          if (this.TableData.SPLIT_PAY == 1) {
            this.SET_STEP(4);
            this.I_SPLITING(true);
            this.I_SET({ key: "SPLIT_PAY", value: this.TableData.SPLIT_PAY });
            this.I_MERGE(data[0]);
            this.I_SET_PRODUCT(prod_detail);
            this.$router.push({ path: "/form" });
            this.LOADER(false);
          } else {
            this.SET_STEP(4);
            this.I_MERGE(data[0]);
            this.I_SET_PRODUCT(prod_detail);
            this.$router.push({ path: "/form" });
            this.LOADER(false);
          }
        } else {
          this.LOADER(false);
        }
      } else {
        this.$swal({
          title: "",
          icon: "warning",
          text:
            "ลูกค้ายังไม่ได้สร้างใบวางบิล / ใบแจ้งหนี้ ต้องการทำใบเสร็จหรือไม่",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        }).then(async (result) => {
          if (result.value) {
            let response = await this.$token_api
              .post("/step-customer-data", {
                NEWCUSTOMER_ID: this.TableData.NEWCUSTOMER_ID,
              })
              .catch((err) => {
                this.LOADER(false);
              });

            let data = response.data.data;
            if (data.length > 0) {
              const prod_detail = await new Response(
                data[0].PRODUCT_LIST
              ).json();
              this.SET_STEP(4);
              this.I_MERGE(data[0]);
              this.I_SET_PRODUCT(prod_detail);
              // this.C_EDIT(true);
              this.$router.push({ path: "/form" });
              this.LOADER(false);
            } else {
              this.LOADER(false);
            }
          } else {
            this.LOADER(false);
          }
        });
      }
    },
    async goToEditCus() {
      this.LOADER(true);
      let response = await this.$token_api
        .post("/get-customer-edit-detail", {
          NEWCUSTOMER_ID: this.TableData.NEWCUSTOMER_ID,
          STATUS: this.TableData.STATUS,
        })
        .catch((err) => {
          this.LOADER(false);
        });

      let data = response.data;
      if (data.length > 0) {
        if (data[0].LIST_DAYS.length > 0) {
          this.CU_EDIT(true);
          this.CU_MERGE(data[0]);
          this.SET_DAYS(data[0].LIST_DAYS);
          console.log(data[0].LIST_PRODUCT);
          this.SET_PRODUCT(data[0].LIST_PRODUCT);
          this.$router.push({ path: "/newCustomer/add-newCustomer" });
          this.LOADER(false);
        } else {
          this.CU_EDIT(true);
          this.CU_MERGE(data[0]);
          this.SET_PRODUCT(data[0].LIST_PRODUCT);
          this.INIT_DAYS();
          this.$router.push({ path: "/newCustomer/add-newCustomer" });
          this.LOADER(false);
        }
      } else {
        this.LOADER(false);
      }
    },
    abort_customer() {
      this.$swal({
        title: "ยืนยันการยกเลิกลูกค้า",
        icon: "warning",
        text: "ต้องการยกเลิกลูกค้ารายนี้หรือไม่",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          this.$token_api
            .post("/abort-customer", {
              NEWCUSTOMER_ID: this.TableData.NEWCUSTOMER_ID,
            })
            .then((response) => {
              this.$parent.$parent.$parent.$parent.listOldcustomer();
            })
            .catch((error) => {});
        }
      });
    },
    reset_customer() {
      this.$swal({
        title: "ยืนยันการรีเซ็ตลูกค้า",
        icon: "warning",
        text: "การรีเซ็ตสถานะจะทำให้สถานะกลับไปเป็น 'รอเสนอราคา'",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          this.$token_api
            .delete("/reset-customer", {
              data: { NEWCUSTOMER_ID: this.TableData.NEWCUSTOMER_ID },
            })
            .then((response) => {
              this.$parent.$parent.$parent.$parent.listOldcustomer();
            })
            .catch((error) => {});
        }
      });
    },
    editWaste_Doc() {
      // console.log(this.TableData);
      // console.log(new Date(this.TableData.W_I));
      //  console.log( moment(this.TableData.W_I).format("HH:MM"));
      //W_SET_ELEMENT
      this.W_SET_ELEMENT({
        key: "W_NAME",
        value: { NEWCUSTOMER_ID: this.TableData.C_ID, N: this.TableData.C_N },
      });
      this.W_SET_ELEMENT({
        key: "W_CARNUMBER",
        value: {
          CAR_ID: this.TableData.CAR_ID,
          CAR_CODE: this.TableData.CAR_TYPE,
          CAR_NUMBER: this.TableData.CAR_NUMBER,
        },
      });
      this.W_SET_ELEMENT({
        key: "W_DRIVER",
        value: {
          PERSONNEL_CID: this.TableData.PD_ID,
          N: this.TableData.PD_NAME + " " + this.TableData.PD_LAST,
        },
      });
      this.W_SET_ELEMENT({
        key: "W_CARRIER",
        value: {
          PERSONNEL_CID: this.TableData.PC_ID,
          N: this.TableData.PC_NAME + " " + this.TableData.PC_LAST,
        },
      });
      this.W_SET_ELEMENT({
        key: "W_DATE_I",
        value: new Date(this.TableData.W_I),
      });
      this.W_SET_ELEMENT({
        key: "W_TIME_I",
        value: moment(this.TableData.W_I).format("HH:MM"),
      });
      this.W_SET_ELEMENT({
        key: "W_TIME_O",
        value: moment(this.TableData.W_O).format("HH:MM"),
      });
      this.W_SET_ELEMENT({ key: "W_WEIGHT", value: this.TableData.W_W });
      this.W_SET_ELEMENT({
        key: "CHEMICAL_WEIGHT11",
        value: this.TableData.TD1_WA_1,
      });
      this.W_SET_ELEMENT({
        key: "CHEMICAL_WEIGHT12",
        value: this.TableData.TD1_WA_2,
      });
      this.W_SET_ELEMENT({
        key: "CHEMICAL_WEIGHT13",
        value: this.TableData.TD1_WA_3,
      });
      this.W_SET_ELEMENT({
        key: "CHEMICAL_WEIGHT14",
        value: this.TableData.TD1_WA_4,
      });
      this.W_SET_ELEMENT({
        key: "INFECTIOUS_WEIGHT21",
        value: this.TableData.TD2_WB_1,
      });
      this.W_SET_ELEMENT({
        key: "INFECTIOUS_WEIGHT22",
        value: this.TableData.TD2_WB_2,
      });
      this.W_SET_ELEMENT({
        key: "INFECTIOUS_WEIGHT23",
        value: this.TableData.TD2_WB_3,
      });
      this.W_SET_ELEMENT({
        key: "INFECTIOUS_WEIGHT24",
        value: this.TableData.TD2_WB_4,
      });
      this.W_SET_ELEMENT({
        key: "DANGER_WEIGHT31",
        value: this.TableData.TD3_WC_1,
      });
      this.W_SET_ELEMENT({
        key: "DANGER_WEIGHT32",
        value: this.TableData.TD3_WC_2,
      });
      this.W_SET_ELEMENT({ key: "TRANSACTION_ID", value: this.TableData.T_ID });
      this.W_SET_ELEMENT({ key: "NEWCUSTOMER_ID", value: this.TableData.C_ID });
      

      this.$token_api
        .post("/get_transection_tracks", {
          TRANSACTION_ID: this.TableData.T_ID,
        })
        .then((response) => {  
          this.W_SET_ELEMENT({
            key: "C_CARNUMBER",
            value: {
              CAR_ID: response.data.data[1].CAR_ID,
              CAR_CODE: response.data.data[1].CAR_TYPE,
              CAR_NUMBER: response.data.data[1].CAR_NUMBER,
            },
          });
          this.W_SET_ELEMENT({
            key: "C_DATE",
            value: new Date(response.data.data[1].TIMESTAMP),
          }); 
          this.W_SET_ELEMENT({
            key: "C_TIME", 
            value: moment(response.data.data[1].TIMESTAMP).format("HH:MM"),
          });
        })
        .catch((err) => {
          console.error(err);
        });
      this.$store.commit("Waste/SET_IS_EDIT", true);
      this.$router.push({ path: "/wastedocument/add-waste-document" });
    },
  },
};
</script>
